/**
 * Frontend feature flags.
 *
 * NEW_UI — switches the default dashboard experience between the new V2 UI and
 * the original (legacy) UI.
 *
 *   NEW_UI = true   → the V2 experience is mounted AT /dashboard (same URLs:
 *                     /dashboard, /dashboard/team, /dashboard/settings, …).
 *                     The legacy pages are NOT reachable.
 *
 *   NEW_UI = false  → original behaviour: legacy UI at /dashboard, and the V2
 *                     experience remains available at /dashboard/v1.
 *
 * Flip this constant and rebuild to switch. Everything else (routing, the V2
 * sidebar nav links, in-app navigation, the trial/plan banners) derives from
 * it via DASHBOARD_BASE below, so there is a single source of truth.
 */
export const NEW_UI = true;

// Base path the V2 shell + all its pages live under. When NEW_UI is on, V2 owns
// the clean /dashboard path; otherwise it stays under /dashboard/v1.
export const DASHBOARD_BASE = NEW_UI ? '/dashboard' : '/dashboard/v1';

/**
 * PULSE_OVERVIEW — the redesigned dashboard overview ("Pulse").
 *
 *   true  → /dashboard shows the Pulse overview: org-health verdict band,
 *           project treemap + movement, the people quadrant, the working-day
 *           dial, day-by-day columns, the week heatmap and the time split.
 *   false → the previous overview (lede + KPI grid + tables) renders instead.
 *
 * Both code paths live in DashboardV2.jsx; flipping this back restores the old
 * page exactly rather than approximately. Everything Pulse draws comes from the
 * reads the dashboard already makes — no new endpoint.
 */
export const PULSE_OVERVIEW = true;
